import { useEffect } from 'react';
import { sentry } from '../index';

/**
 * Starts a sentry span with no timing data attached to it.
 * This is useful for marking a point in time in the waterfall of spans.
 * @param name - should include the component name and what happened, e.g. 'GlobalNav mounted'
 * @param op - operation name, defaults to 'ui.react.mount'. See sentry documentation: https://develop.sentry.dev/sdk/telemetry/traces/span-operations/#js-frameworks
 * @param startTime - optional start time in milliseconds
 */
export function useSentrySpanMarker(name: string, op = 'ui.react.mount', startTime?: number) {
  useEffect(() => {
    sentry.instance.startSpan({ name, op, startTime }, () => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps -- name and op should be stable and if they do change, the effect will run again which will mess up perf timings
  }, []);
}
